module.exports = __webpack_public_path__ + "static/media/LAT.c7df339a.png";